import React from "react";
import { Form, Radio, Space, Input, Button, message } from "antd";
import api from "utils/api";
import { ArrowRightOutlined } from "@ant-design/icons";
import { connect } from 'react-redux';
import { setNotesDone} from "store/slice/videoConsultation-slice";
import SubmitButton from "../Patient/SubmitButton"
import "./CaseNotes.scss";
import { currentTab, switchCasesheetTabs } from "store/slice/tabs-slice";
import { CONSTANTS } from "utils/constant";
import Loader from "Components/Loader";


class Notes extends React.Component {

    constructor(props) {
        super(props);
        let { appointment_id, remoteUser, appointment_date } = this.props.data || {};
        this.state = {
            appointment_id, remoteUser, appointment_date,
            casenotesValues: true,
            casenotes: {},
            casenotesDisable: false,
            casenotestext: '',
            form_action: false,
            disable_btn:true,
            buttonLoading : true,
            is_casenotes_required : true,
            isLoading: true,
        }

        this.form = React.createRef()
    }


    componentWillUnmount = () => {
        localStorage.setItem("reloadNotes", true);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.data !== prevState.data) {
            return { data: nextProps.data }
        }
        else return null;
    }

    componentDidMount = () => {
        this.getNotesConsultation();
        this.notesUpdate();
        this.props.formAction(false)

    }

    notesUpdate() {
        if (this.props.updateData) {
            this.form.current?.setFieldsValue({ casenotes: this.state.casenotes })
        } else {
            this.form.current?.setFieldsValue({ casenotes: "" })
        }
    }


    getNotesConsultation() {
        let data = {
            app_id: this.state.appointment_id,
            type: "casenotes"
        }
        api.get_consultation_details(data)
            .then((response) => {
                // let tempNotes = (response.data.data?.results.casenotes || []).map((m, i) => {
                //     return m.casesheet
                // })
                let tempNotes = response.data.data?.results?.casenotes[0]?.casesheet || "";
                this.setState({ casenotes: tempNotes, buttonLoading: false, isLoading:false });
                if(tempNotes?.length>0){
                    this.setState({disable_btn:false})
                }
                this.form.current?.setFieldsValue({ casenotes: tempNotes });
                if(tempNotes){
                    this.setState({submittedCaseNotes:true})
                }
                // message.success(res.data?.message, ErrorDuration);
                this.state?.casenotes?.length > 0 ? this.setState({ casenotesDisable: true }) : this.setState({ casenotesValues: false });
                (response.data.data?.results?.casenotes[0]?.missed_casesheet || response.data.data?.results?.casenotes[0]?.is_casenotes_required == false) ? 
                this.form.current?.setFieldsValue({ missed_casenotes: true }):  
                this.form.current?.setFieldsValue({ missed_casenotes: false })
                this.setState({is_casenotes_required : response.data.data?.results?.casenotes[0]?.is_casenotes_required == false ? false : true})
                this.props.formAction(false);
            })
            .catch(() => {

            })
    }

    componentWillUnmount() {
        if (this.state.form_action) {
            this.props.formAction(true)
        }
    }
    onSubmit(values) {
       this.setState({buttonLoading: true})
        api
            .casesheet_submit({ ...values,is_casenotes_required : !values.missed_casenotes , appointment_id: this.state.appointment_id })
            .then((res) => {
                if (res.data?.status == 200) {
                    if(values.missed_casenotes)
                   {
                    this.setState({casenotestext:""})
                }
                        
                    message.success(res.data?.message, ErrorDuration);
                   typeof this.props.handleFunction == "function" && this.props.handleFunction({ is_casenotes: !values.missed_casenotes });
                    this.setState({ submittedCaseNotes: true, notesDone: true, casenotesDisable: true,disable_btn:false, buttonLoading: false });
                    this.props.setNotesDone(this.state.notesDone);
                    this.props.formAction(false);

                }
            })
            .catch((err) => { });
    }

    render() {
    
        return (
            <>
            {       
            this.state.isLoading?
            <Loader/>:
                <div style={this.props.style || {}} className="notes-container video-casenotes-consultation-wrapper">
                    <Form
                        onFinish={this.onSubmit.bind(this)}
                        onFieldsChange={() => this.props.formAction(true)}
                        ref={this.form}
                        colon={false}
                        labelWrap
                        labelAlign="left"
                        labelCol={{ span: 24 }}
                        wrapperCol={{ span: 24 }}
                        initialValues={{
                            missed_casenotes: this.state.casenotesDisable,
                            casenotes: ''
                        }}
                    >
                        <Form.Item
                            name="missed_casenotes"
                            rules={[{
                                required: true,
                                message: "Required",
                            },]}
                            className="missed-case-notes-container"
                        >
                            <Radio.Group
                                // disabled={this.props.is_casesheet?true:false}
                                // options={[{ label: "No Casenotes required for this consultation !!", value: true }, { label: "Add Casesheet", value: false }]}
                                onChange={e => {
                                    let { value } = e.target
                                    if (value) {
                                        let text = this.form.current?.getFieldsValue().casenotes
                                        this.form.current?.setFieldsValue({ casenotes: "" })
                                        this.setState({ casenotesValues: true, casenotestext: text,disable_btn:false })


                                    }
                                    if (!value) {
if(this.state?.casenotestext?.length==0){
    this.setState({disable_btn:true })
}
                                        this.setState({ casenotesValues: false})
                                        this.form.current?.setFieldsValue({ casenotes: this.state.casenotestext ,})
                                    }
                                }}

                            // disabled={this.state.submittedCaseNotes}
                            >
                                <Space direction="vertical">
                                    <Radio value={true}>
                                        No Casenotes required for this consultation!
                                    </Radio>
                                    <Radio value={false}>Add Casenotes</Radio>
                                </Space>
                            </Radio.Group>
                        </Form.Item>
                        {/* <div className="appointment-details">
                            <div>{utils.ConvertToPascalCase(this.props.data.remoteusr)},</div>
                            <div>{utils.FormatDate(this.props.data.appointment_date, "DATE_1")}</div>
                        </div> */}
                        <Form.Item className="child-list" shouldUpdate={(prevValues, curValues) => prevValues.missed_casenotes !== curValues.missed_casenotes}>
                            {
                                () => {
                                    let show = this.form.current?.getFieldValue("missed_casenotes");
                                    return (
                                        <Form.Item
                                            label="Notes"
                                            name="casenotes"
                                            labelCol={{ span: 24 }}
                                            wrapperCol={{ span: 24 }}
                                            rules={[{
                                                required: !this.state.casenotesValues,
                                                message: "Please add notes!",
                                            }]}
                                            onChange={(e)=>{
                                                { if(e.target.value.trim().length>0){
                                                    this.setState({disable_btn:false})}
                                                    else 
                                                        e.target.value.trim().length==0?
                                                      this.setState({disable_btn:true})
                                                    :null
                                                  }
                                            }}
                                        >

                                            <Input.TextArea
                                                disabled={show == true}
                                                rows={4}
                                                placeholder="Type here"


                                            />
                                        </Form.Item>
                                    )
                                }
                            }
                        </Form.Item>
                    </Form>
                    <div className="submit-button-wrapper">
                    {(!this.props.updateData && this.state.is_casenotes_required) ? 
                    <SubmitButton disabled={!this.state.submittedCaseNotes? this.state.disable_btn :false} className={this.state.disable_btn?"disable-btn":"common-btn"} onClick={e => this.form.current?.submit()} label={this.state.submittedCaseNotes ? `${CONSTANTS.UPDATE}`: `${CONSTANTS.SUBMIT}`} loading={this.state.buttonLoading}/>
                    :<SubmitButton disabled={this.state.disable_btn && this.state.is_casenotes_required} className={"common-btn"} onClick={e => this.form.current?.submit()} label={CONSTANTS.UPDATE} loading={this.state.buttonLoading}/>
                    // <Button disabled={ !this.state.submittedCaseNotes? this.state.disable_btn :false} className={this.state.disable_btn?"disable-btn":"common-btn"} onClick={e => this.form.current?.submit()} >{!this.state.submittedCaseNotes ? "Submit" : "Update"}<ArrowRightOutlined /></Button> :
                    //     <Button className="common-btn" disabled={ !this.state.submittedCaseNotes? this.state.disable_btn :false} onClick={e => this.form.current?.submit()} >Update<ArrowRightOutlined /></Button>
                        }

                </div> 
                    
                </div>
    }
            </>
        )
    }
}
const mapStateToProps = state => {
    return {
        submittedDetails: state.videoConsultationReducer.notesDone,
        switch_casesheet_tabs: state.tabsReducer.switch_casesheet_tabs,
        updateData: state.videoConsultationReducer.updateData?.is_casesheet

    }
}
const mapDispatchToProps = {
    setNotesDone,
    currentTab,
    switchCasesheetTabs
}
export default connect(mapStateToProps, mapDispatchToProps)(Notes);